import BrowseActions from "./browseActions";
import BrowseFilterChips from "./browseFilterChips";
import BrowseSearchBar from "./browseSearchBar";
import { AdvancedSearchParams } from "./types";

type BrowseControlsProps = {
  searchQuery: string;
  getCurrentFolderName: () => string;
  onSearchChange: (value: string) => void;
  onClearSearch: () => void;
  onOpenAdvancedSearch: () => void;
  activeFilters: AdvancedSearchParams | null;
  onClearFileType: (fileType: string) => void;
  onClearDateModified: () => void;
  onClearAllFilters: () => void;
  isCurrentFolderRestricted: boolean;
  selectedItemsCount: number;
  onDeleteSelected: () => void;
  onNewFolder: () => void;
  onUploadFile: () => void;
  onUploadFolder: () => void;
  viewMode: "grid" | "list";
  onViewModeChange: (mode: "grid" | "list") => void;
  sortBy: "name" | "size" | "modified" | "none";
  sortOrder: "asc" | "desc";
  onSelectSortBy: (value: "name" | "size" | "modified" | "none") => void;
  onSelectSortOrder: (value: "asc" | "desc") => void;
};

const BrowseControls = ({
  searchQuery,
  getCurrentFolderName,
  onSearchChange,
  onClearSearch,
  onOpenAdvancedSearch,
  activeFilters,
  onClearFileType,
  onClearDateModified,
  onClearAllFilters,
  isCurrentFolderRestricted,
  selectedItemsCount,
  onDeleteSelected,
  onNewFolder,
  onUploadFile,
  onUploadFolder,
  viewMode,
  onViewModeChange,
  sortBy,
  sortOrder,
  onSelectSortBy,
  onSelectSortOrder,
}: BrowseControlsProps) => (
  <div className="flex flex-col gap-3">
    <div className="flex items-center justify-between gap-4 relative z-50">
      <div className="flex items-center gap-2 flex-1">
        <BrowseSearchBar
          searchQuery={searchQuery}
          getCurrentFolderName={getCurrentFolderName}
          onSearchChange={onSearchChange}
          onClearSearch={onClearSearch}
          onOpenAdvancedSearch={onOpenAdvancedSearch}
        />
      </div>
      <BrowseActions
        isCurrentFolderRestricted={isCurrentFolderRestricted}
        selectedItemsCount={selectedItemsCount}
        onDeleteSelected={onDeleteSelected}
        onNewFolder={onNewFolder}
        onUploadFile={onUploadFile}
        onUploadFolder={onUploadFolder}
        viewMode={viewMode}
        onViewModeChange={onViewModeChange}
        sortBy={sortBy}
        sortOrder={sortOrder}
        onSelectSortBy={onSelectSortBy}
        onSelectSortOrder={onSelectSortOrder}
      />
    </div>
    <BrowseFilterChips
      activeFilters={activeFilters}
      onClearFileType={onClearFileType}
      onClearDateModified={onClearDateModified}
      onClearAll={onClearAllFilters}
    />
  </div>
);

export default BrowseControls;
